import getEsQuery, {getDataSources} from '../esParser'
import ElasticsearchAPI from '../../ElasticsearchAPI'

async function universeEstimate(payload) {
  const jsonQuery = payload.query

  const esSearch = getEsQuery(jsonQuery, payload)
  esSearch.aggs = getUeAggregation(jsonQuery)

  const response = await ElasticsearchAPI.universeEstimate(esSearch)
  const results = response
  const aggregations = results.aggregations
  if (!aggregations || !aggregations.average_universe || !aggregations.average_universe.value)
    return { data: { stable: false, universe: [], audience: 0 } }

  // const averageUniverse = aggregations.atsg.average_universe.value || 0
  const datasources = getDataSources(jsonQuery)
  let filterFn = b => b
  if (datasources.has('mri') && datasources.has('ncs')) {
    filterFn = b => b.mri.doc_count > 0 && b.ncs.doc_count > 0
  } else if (datasources.has('mri')) filterFn = b => b.mri.doc_count > 0
  else if (datasources.has('ncs')) filterFn = b => b.ncs.doc_count > 0

  const monthBuckets = aggregations.by_month.buckets
  // we don't need to sort result since histogram buckets always return in ascending order
  // see: https://www.elastic.co/guide/en/elasticsearch/reference/7.10/search-aggregations-bucket-datehistogram-aggregation.html#date-histogram-order
  const averageUniverse = getAverage(
    monthBuckets
      .filter(filterFn)
      .map(b => b.monthly_universe.value)
      .slice(-3),
  )
  const monthResult = monthBuckets.map(m => ({ date: `${m.key_as_string}-01`, size: m.monthly_universe.value }))
  const ueValues = monthResult.map(m => m.size)

  let ueStability = 1
  if (ueValues.length >= 2) ueStability = getStandardDeviation(ueValues) / getAverage(ueValues)
  return {
    data: {
      audience: averageUniverse,
      stable: ueStability < 1 && averageUniverse > 10000000,
      universe: monthResult,
    },
  }
}

// source: https://stackoverflow.com/a/53577159
function getStandardDeviation(arr) {
  if (!arr || arr.length === 0) return 0
  const n = arr.length
  const mean = arr.reduce((a, b) => a + b) / n
  return Math.sqrt(arr.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n)
}

function getAverage(arr) {
  return arr.reduce((a, b) => a + b) / arr.length
}

function getUeAggregation() {
  return {
    by_month: {
      date_histogram: { field: 'broadcastdate', interval: 'month', format: 'yyyy-MM' },
      aggs: {
        monthly_universe: { sum: { field: 'intabweight' } },
        mri: {
          filter: {
            exists: {
              field: 'mri.mri_yes',
            },
          },
        },
        ncs: {
          filter: {
            exists: {
              field: 'ncs.ncs_yes',
            },
          },
        },
      },
    },
    average_universe: { avg_bucket: { buckets_path: 'by_month>monthly_universe' } },
  }
}

export default universeEstimate



// WEBPACK FOOTER //
// ./src/app/api/elasticsearch/LAS/universeEstimate.js